import { webToast } from "@/assets/js/alertPopShow";
import axios from 'axios'
export default {
  wxpostData(url,data,success,always){
    var that = this;
    var address = 'http://pl.ayunlian.com';
    axios({
      url: address + url,
      method:'post',
      data:data,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
    })
      .then(function (res) {
        if(res.data.status == 200 || res.data.status == 201 || res.data.status == 503 ){
          success && success(res.data);
        }
        if( res.data.status == 404 ){
          webToast(res.data.message,'middle',1500);
        }
        //未关注公众号
        if( res.data.status == 501 ){
          webToast(res.data.message,'middle',1500);
          var goFocus = setTimeout(function () {
            window.location.href = '/focus';
          },1500)
        }
        //token错误
        if( res.data.status == 502 ){
          webToast(res.data.message,'middle',1500);
          localStorage.removeItem('openid');
          var goFocus = setTimeout(function () {
            window.location.href = '/';
          },1500)
        }
        //没有数据
        // if( res.data.status == 503 ){
        //   webToast(res.data.message,'middle',1500);
        // }
      })
      .finally(function (res) {
        // always executed
        always && always(res);
      });
  },
  // 微信jssdk
  wxjssdk(url){
    var that = this;
    var obj = new Object();
    obj.url = encodeURIComponent(url);
    // alert(url);
    that.wxpostData('/api.php/Common/getJssdk',obj
      ,result =>{
        console.log(result.content);
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: result.content.appId, // 必填，公众号的唯一标识
          timestamp: result.content.timestamp, // 必填，生成签名的时间戳
          nonceStr: result.content.nonceStr, // 必填，生成签名的随机串
          signature: result.content.signature,// 必填，签名
          jsApiList: [
            'updateTimelineShareData',//1.4.0的分享接口，注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
            'updateAppMessageShareData',//1.4.0的分享接口,注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
            'onMenuShareAppMessage',//老版本分享接口。
            'onMenuShareTimeline',//老版本分享接口。
            'scanQRCode',//微信扫一扫接口。
            'chooseImage',//微信拍照或从手机相册中选图接口。
            'previewImage',//预览图片接口
            'uploadImage',//上传图片接口
            'openAddress',//获取收货地址
            'chooseWXPay',//微信支付
            'openLocation',//打开地图
          ], // 必填，需要使用的JS接口列表
          openTagList: [
            'wx-open-launch-weapp',//小程序跳转按钮
          ] // 必填，需要使用的开放标签
        });
        wx.ready(function () {
          var share_url = 'http://badata.ayunlian.com';
          // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.updateAppMessageShareData({
            title: '东莞市江西商会 - 大数据平台', // 分享标题
            desc: '东莞市链讯信息科技有限公司提供技术支持 查建文13712883719', // 分享描述
            link: share_url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'http://pl1.ayunlian.com/pl_logo.png?time=20201116', // 分享图标
            success: function () {
              // 设置成功
            }
          })
          // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          wx.updateTimelineShareData({
            title: '东莞市江西商会 - 大数据平台', // 分享标题
            desc: '东莞市链讯信息科技有限公司提供技术支持 查建文13712883719', // 分享描述
            link: share_url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'http://pl1.ayunlian.com/pl_logo.png?time=20201116', // 分享图标
            success: function () {
              // 设置成功
            }
          })
        })
      })
  },
  // 数据交互
  postData(url,data,success,always){
    var that = this;
    var address = 'http://badata.ayunlian.com';
    axios({
      url: address + url,
      method:'post',
      data:data,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
    })
      .then(function (res) {
        if(res.data.status == 200 || res.data.status == 201 || res.data.status == 503 ){
          success && success(res.data);
        }
        if( res.data.status == 404 ){
          webToast(res.data.message,'middle',1500);
        }
        //未关注公众号
        if( res.data.status == 501 ){
          webToast(res.data.message,'middle',1500);
          var goFocus = setTimeout(function () {
            window.location.href = '/focus';
          },1500)
        }
        //token错误
        if( res.data.status == 502 ){
          webToast(res.data.message,'middle',1500);
          localStorage.removeItem('openid');
          var goFocus = setTimeout(function () {
            window.location.href = '/';
          },1500)
        }
        //没有数据
        // if( res.data.status == 503 ){
        //   webToast(res.data.message,'middle',1500);
        // }
      })
      .finally(function (res) {
        // always executed
        always && always(res);
      });
  },
  // 七牛上传
  qiniuUpload(data,success,always){
    var that = this;
    axios({
      url: 'https://up-z2.qiniup.com',
      method:'post',
      data:data,
      // header: {
      //   "content-type": "multipart/form-data"
      // },
      headers:{
        'Content-Type':'multipart/form-data'
      }
    })
      .then(function (res) {
        if(res.data.status == 200 || res.data.status == 201 || res.data.status == 503 ){
          success && success(res.data);
        }
        if( res.data.status == 404 ){
          webToast(res.data.message,'middle',1500);
        }
      })
      .finally(function (res) {
        // always executed
        always && always(res);
      });
  },
  // 返回上一页
  returnPage(){
    var that = this;
    that.$router.go(-1);
  },
  // 首页swiper 初始化
  initHomeSwiper(){
    $(function () {
      var mySwiper = new Swiper('.swiper-container', {
        direction: 'vertical', // 垂直切换选项
        autoplay: {
          delay: 1500,//1秒切换一次
          disableOnInteraction: false,
        },
        // loop:true,
        width: window.innerWidth,
        hashNavigation: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        slidesPerView: 3,//显示2行
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          bulletClass:'swiper_dots',
          bulletActiveClass:'swiper_dots_act'
        },
      })
    })
  },
  // 初始化签到轮播
  sign_swiper_init(){
    $(function () {
      var mySwiper = new Swiper ('.swiper-container', {
        loop: false, // 循环模式选项
        slidesPerView: 8,//显示2行
        direction: 'vertical', // 垂直切换选项
        autoplay: {
          delay: 1000,//1秒切换一次
          disableOnInteraction: false,
        },
        // loop:true,
        width: window.innerWidth,
        hashNavigation: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
      })
    })
  },
  // 验证登录
  checkLogin() {
    return localStorage.getItem('openid');
  },
  // 前往登录页
  goLogin(){
    this.$router.push({ name:'login' })
  },
  // 秒杀计时器
  runTime2(end_time,begin,end) {
    var that = this;
    var total = end_time - 1;
    if (Number(total) > 0) {
      that.end_time = total;
      //计算整数天数
      var day = parseInt(total / (24 * 60 * 60));
      //取得算出天数后剩余的秒数
      var afterDay = total - day * 24 * 60 * 60;
      //计算整数小时数
      var hour = parseInt(afterDay / (60 * 60));
      //取得算出小时数后剩余的秒数
      var afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60;
      //计算整数分
      var min = parseInt(afterHour / 60);
      //取得算出分后剩余的秒数
      var s = total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60;
      var actTime = hour + '时' + min + '分' + s + '秒';
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (hour >= 10) {
        hour = hour;
      }
      if (min < 10) {
        min = '0' + min;
      }
      if (min >= 10) {
        min = min;

      }
      if (s < 10) {
        s = '0' + s;
      }
      if (s >= 10) {
        s = s;
      }
      var arr = [total,hour,min,s];
      begin && begin(arr);//计时开始 返回arr数据
      return false;
    }
    end && end();//计时结束 返回操作
  },
  // 获取对话框状态值 0 cancel 1 confirm
  diaLogCallback(status,confirm,cancel){
    if( status == '1' ){
      confirm && confirm();
      return false;
    }
    if( status == '0' ){
      cancel && cancel();
      return false;
    }
  },
  // 拨打电话 联系客服
  callPhone(success) {
    var that = this;
    that.postData('/api.php/Common/getConfigInfo',{}
      ,result =>{
        success && success(result.content.cs_phone);
      })
  },
  // 跳转登录
  jumpLogin(callback) {
    var that = this;
    if (!that.checkLogin()) {
      wx.showActionSheet({
        itemList: ['微信授权登录', '账号密码登录'],
        success (res) {
          if( res.tapIndex == '0' ){
            wx.navigateTo({
              url: '/pages/login/login?type=wxLogin',
            })
          }
          if( res.tapIndex == '1' ){
            wx.navigateTo({
              url: '/pages/login_account/login_account?type=accLogin',
            })
          }
        },
        fail (res) {
          console.log(res.errMsg)
        }
      })
      return false;
    }
    callback && callback();
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js